import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CurrencyFormat } from '../../../utils';

import useConfiguratorData from '../../hooks/useConfiguratorData';
import useAccessoriesData from '../../hooks/useAccessoriesData';
import usePriceData from '../../hooks/usePriceData';
import useLinksData from '../../hooks/useLinksData';
import useLeadData from '../../hooks/useLeadData';
import usePersonalData from '../../hooks/usePersonalData';
import useFinanciadoData from '../../hooks/useFinanciadoData';

import ModalConfigurationDetail from './../Modals/ModalConfigurationDetail';
import ModalContact from './../Modals/ModalContactMe';
import ModalCustomMessage from './../Modals/ModalCustomMessage';

const Summary = () => {

    const { getSelectedModel, getSelectedVersion, getSummary, getSelectedPrepaidMaintenancePlan, getInactiveModalUsed, setInactiveModalUsed } = useConfiguratorData();
    const { getSimulateDownpaymentPercentage, getSimulateNumberFees, getSimulatedCreditData } = useFinanciadoData();
    const { getAddedAccessories, getIgnoreAccessories } = useAccessoriesData();
    const { getFinalPrice, getFinancedTotal } = usePriceData();
    const { getLinks } = useLinksData();
    const { updateLead, sendFinancingSummaryEmail, createSalesforceLead, updateSalesforceLead, getSalesforceLeadId } = useLeadData();
    const { getPersonalData } = usePersonalData();
    const [isOpen, setIsOpen] = useState(false);
    const [modalContactisOpen, setModalContactIsOpen] = useState(false);
    const [needContact, setNeedContact] = useState(true);
    const [modalCustomMessageIsOpen, setModalCustomMessageIsOpen] = useState(false);
    const [processing, setProcessing] = useState(false);
    const history = useHistory();

    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();
    const accessories = getAddedAccessories();
    const ignoreAccessories = getIgnoreAccessories();
    const finalPrice = getFinancedTotal();
    const links = getLinks();
    const personalData = getPersonalData();
    const simulateDownpaymentPercentage = getSimulateDownpaymentPercentage();
    const simulateNumberFees = getSimulateNumberFees();
    const simulatedCreditData = getSimulatedCreditData();
    const selectedPrepaidMaintenancePlan = getSelectedPrepaidMaintenancePlan();
    const salesforceLeadId = getSalesforceLeadId()

    const motor_type = selectedVersion.motor.name;
    const modelo_name = selectedModel.name;

    useEffect(() => {
        setNeedContact(true)
    }, [selectedVersion, simulateNumberFees, simulateDownpaymentPercentage, simulatedCreditData, ignoreAccessories, selectedPrepaidMaintenancePlan])

    const handleViewSummaryButton = () => {
        updateLead();
        setIsOpen(true);
    }

    const handleContactMeButton = () => {
        updateLead([{
            name: 'quiero-que-me-contacten',
            value: 'Si'
        }], () => {
            setModalContactIsOpen(true); // exito
            setInactiveModalUsed(true);   

            // Create or updtae salesforce lead
            if (!salesforceLeadId) {
                createSalesforceLead([{
                    name: 'quiero-que-me-contacten',
                    value: 'Si'
                }])
            } else {
                updateSalesforceLead([{
                    name: 'quiero-que-me-contacten',
                    value: 'Si'
                }])
            };
        }, () => {
            setModalContactIsOpen(true); // error
            setInactiveModalUsed(true);
        });
    };

    const sendEmail = () => {
        setProcessing(true)
        sendFinancingSummaryEmail((response) => {
            setModalCustomMessageIsOpen(true);
            setNeedContact(false);
            setProcessing(false);
            setInactiveModalUsed(true);
        }, (error) => {
            setNeedContact(true);
            setProcessing(false);
            setInactiveModalUsed(true);
            console.log(error)
        })
        updateLead([{
            name: 'quiero-que-me-contacten',
            value: 'No'
        }], () => {
            // setNeedContact(false) // exito 

            // Create or update salesforce lead
            if (!salesforceLeadId) {
                createSalesforceLead([{
                    name: 'quiero-que-me-contacten',
                    value: 'No'
                }])
            } else {
                updateSalesforceLead([{
                    name: 'quiero-que-me-contacten',
                    value: 'No'
                }])
            };
        }, () => {
            // setNeedContact(false) // error
        });
    };

    return (
        <div className="summary">
            <div className="component-header">
                <h2>Resumen</h2>
            </div>
            <div className="grey-box">
                <span>{selectedModel.name} {selectedVersion.name}{!ignoreAccessories.value && accessories.length ? ` + ${accessories.length} accesorios` : null}{selectedPrepaidMaintenancePlan ? ` + mantenciones` : null}</span>
                <div className='price'>
                    <h1>{CurrencyFormat(finalPrice)} <sup>(&lowast;)</sup></h1>
                    <p className='green-tax'><small>+I.V. {CurrencyFormat(selectedVersion.green_tax)}</small></p>
                </div>
                <a className="btn summary-link" onClick={() => handleViewSummaryButton()}>Ver Resumen</a>
                <div className="divider-line"><hr></hr></div>
                <div className="text-box">
                    {!needContact ?
                        <p>Gracias por compartirnos tus preferencias.</p>
                        : null}
                </div>
                <div className="hrow">
                    <button className={"btn contactarme-envio-cotizacion " + (needContact ? "black" : "outline-black")} onClick={() => handleContactMeButton()}>Contactarme y enviar cotización</button>
                    {needContact ?
                        <button className="btn outline-black solo-enviar-cotizacion" disabled={processing} onClick={() => sendEmail()}>Solo enviar cotización <img style={{ display: processing ? 'inline' : 'none' }} className="ajax-loader" src={`${window._env_.STATIC_HOST}/static/website/images/ajax-loader.gif`} /></button>
                        : null}
                </div>
            </div>
            <div className="tnc-container">
                {links.tnc_by_model_page ? (
                    <span className="tnc">
                        * <a href={links.tnc_by_model_page} target="_blank">Precio Sugerido. Ver Términos y Condiciones Legales</a>
                    </span>
                ) : null}
                {selectedVersion.iva_warning ? (<p className="version_warning">Precio incluye IVA</p>) : null}
                {selectedVersion.stock_warning ? (<p className="version_warning">Consultar disponibilidad</p>) : null}
            </div>
            <ModalConfigurationDetail isOpen={isOpen} onCloseModal={() => setIsOpen(false)} />
            <ModalContact isOpen={modalContactisOpen} onCloseModal={() => setModalContactIsOpen(false)} />
            <ModalCustomMessage
                isOpen={modalCustomMessageIsOpen}
                onCloseModal={() => setModalCustomMessageIsOpen(false)}
                title="¡Muchas Gracias!"
                message={`Gracias por tu interés en ${selectedModel.name} ${selectedVersion.name}. Te enviamos la cotización a ${personalData.email}.`}
                textButton="¡Listo!"
            />
        </div>
    )
}

export default Summary;